import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "refetch"],
  _excluded2 = ["data", "refetch"];
const _unique = definitions => {
  const names = {};
  return definitions.filter(definition => {
    if (definition.kind !== 'FragmentDefinition') {
      return true;
    }
    const name = definition.name.value;
    if (names[name]) {
      return false;
    } else {
      names[name] = true;
      return true;
    }
  });
};
import { useCallback, useMemo } from 'react';
import { useQuery, gql } from '@apollo/client';
import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery as useDFCQuery } from 'data-fetching-client';
import listingLibPerformanceTracking, { MEASURE_MARK_NAMES } from 'framework-listing-lib/internal/utils/performanceTracking';
import { makeQuickFetchRequest } from 'framework-listing-lib/utils/quickFetch';
import { Metrics } from 'framework-listing-lib/internal/metrics';
import { CRM_OBJECT_FRAGMENT } from 'framework-listing-lib/internal/graphql/fragments';
import useHasGraphQLCrmSearch from 'framework-listing-lib/internal/graphql/hooks/useHasGraphQLCrmSearch';
import { transformGraphQLResponseIntoCrmSearchResponse, getGraphQLVariables } from 'framework-listing-lib/internal/graphql/utils/graphql';
export const LISTING_LIB_CRM_SEARCH_QUERY = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"ListingLibCrmSearchQuery\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"count\"}},\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Int\"}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"filterGroups\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"ListType\",\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"FilterGroup\"}}}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectTypeId\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"offset\"}},\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Int\"}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"query\"}},\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"sorts\"}},\"type\":{\"kind\":\"ListType\",\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Sort\"}}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"associationSpecs\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"ListType\",\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"AssociationSpec\"}}}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"hasAssociationSpecs\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Boolean\"}}},\"defaultValue\":{\"kind\":\"BooleanValue\",\"value\":false}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"timeZoneId\"}},\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"crmObjectsSearch\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"count\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"count\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"filterGroups\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"filterGroups\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"offset\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"offset\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"query\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"query\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"sorts\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"sorts\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"type\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectTypeId\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"timeZoneId\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"timeZoneId\"}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hasMore\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"offset\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"results\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"CrmObjectFragment\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"total\"}}]}}]}}]}", {
  id: null,
  kind: "Document",
  definitions: _unique([{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "ListingLibCrmSearchQuery"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "count"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "Int"
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "filterGroups"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "ListType",
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "FilterGroup"
              }
            }
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "objectTypeId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "offset"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "Int"
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "query"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "String"
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "sorts"
        }
      },
      type: {
        kind: "ListType",
        type: {
          kind: "NonNullType",
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "Sort"
            }
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "associationSpecs"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "ListType",
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "AssociationSpec"
              }
            }
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "hasAssociationSpecs"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Boolean"
          }
        }
      },
      defaultValue: {
        kind: "BooleanValue",
        value: false
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "timeZoneId"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "String"
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "crmObjectsSearch"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "count"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "count"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "filterGroups"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "filterGroups"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "offset"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "offset"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "query"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "query"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "sorts"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "sorts"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "type"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "objectTypeId"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "timeZoneId"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "timeZoneId"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "hasMore"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "offset"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "results"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "FragmentSpread",
                name: {
                  kind: "Name",
                  value: "CrmObjectFragment"
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "total"
            }
          }]
        }
      }]
    }
  }].concat(CRM_OBJECT_FRAGMENT.definitions))
});
export const CRM_OBJECT_TYPE_FIELD_NAME = 'crmObjectType';
export const CRM_OBJECT_TYPE_QUERY = registerQuery({
  fieldName: CRM_OBJECT_TYPE_FIELD_NAME,
  args: ['fetcher', 'fetchParams', 'quickFetchName', 'removeAfterFetch'],
  fetcher({
    fetcher,
    fetchParams,
    quickFetchName,
    removeAfterFetch
  }) {
    const quickFetchArg = quickFetchName || `fetch-crm-objects-${fetchParams.objectTypeId}`;
    const crmSearchRequest = () => fetcher ? fetcher(fetchParams) : http.post('/crm-search/search', {
      data: fetchParams
    });
    let performanceTracking;
    if (quickFetchArg === `fetch-crm-objects-${fetchParams.objectTypeId}`) {
      performanceTracking = listingLibPerformanceTracking.getPerformanceTracking(MEASURE_MARK_NAMES.CRM_SEARCH);
      performanceTracking.markTimeStart();
    }
    return makeQuickFetchRequest({
      makeRequestFn: crmSearchRequest,
      requestName: quickFetchArg,
      removeAfterFetch
    }).then(response => {
      Metrics.counter('crm-search-success', {
        object_type_id: fetchParams.objectTypeId
      }).increment();
      if (performanceTracking) {
        performanceTracking.markTimeEnd();
      }
      return response;
    }).catch(error => {
      Metrics.counter('crm-search-failure', {
        object_type_id: fetchParams.objectTypeId
      }).increment();
      throw error;
    });
  }
});
function useTrackPerfEnd(variables) {
  const initialQuickFetch = useMemo(() => `fetch-crm-objects-${variables.fetchParams.objectTypeId}`, [variables.fetchParams.objectTypeId]);
  const quickFetchArg = useMemo(() => variables.quickFetchName || initialQuickFetch, [initialQuickFetch, variables.quickFetchName]);
  const shouldTrack = quickFetchArg === initialQuickFetch;
  let performanceTracking;
  if (shouldTrack) {
    performanceTracking = listingLibPerformanceTracking.getPerformanceTracking(MEASURE_MARK_NAMES.CRM_SEARCH);
    performanceTracking.markTimeStart();
  }
  return useCallback(() => {
    if (performanceTracking) {
      performanceTracking.markTimeEnd();
    }
  }, [performanceTracking]);
}
export default function useFetchFromCRM(variables, options) {
  const hasGraphQLCrmSearch = useHasGraphQLCrmSearch();
  const incomingOptions = useMemo(() => Object.assign({}, options || {}), [options]);

  /**
   * Force a skip on the REST call when GraphQL is turned on
   */
  const restOptions = useMemo(() => {
    if (hasGraphQLCrmSearch) {
      return Object.assign({}, incomingOptions, {
        skip: true
      });
    }
    return incomingOptions;
  }, [hasGraphQLCrmSearch, incomingOptions]);

  /**
   * Force a skip on the GraphQL call when GraphQL is turned off
   */
  const graphQLOptions = useMemo(() => {
    if (hasGraphQLCrmSearch) {
      return incomingOptions;
    }
    return Object.assign({}, incomingOptions, {
      skip: true
    });
  }, [hasGraphQLCrmSearch, incomingOptions]);
  const _useDFCQuery = useDFCQuery(CRM_OBJECT_TYPE_QUERY, Object.assign({
      variables
    }, restOptions)),
    {
      data,
      refetch: refetchDFC
    } = _useDFCQuery,
    rest = _objectWithoutPropertiesLoose(_useDFCQuery, _excluded);
  const trackPerfEnd = useTrackPerfEnd(variables);
  const _useQuery = useQuery(LISTING_LIB_CRM_SEARCH_QUERY, Object.assign({
      variables: getGraphQLVariables(variables),
      errorPolicy: 'all',
      returnPartialData: true
    }, graphQLOptions, {
      onCompleted: () => {
        Metrics.counter('crm-search-graphql-success', {
          object_type_id: variables.fetchParams.objectTypeId
        }).increment();
        trackPerfEnd();
      },
      onError: () => {
        Metrics.counter('crm-search-graphql-failure', {
          object_type_id: variables.fetchParams.objectTypeId
        }).increment();
      }
    })),
    {
      data: graphQLData,
      refetch: refetchGraphQL
    } = _useQuery,
    restGraphQL = _objectWithoutPropertiesLoose(_useQuery, _excluded2);
  const refetch = useCallback(refetchVariables => {
    const finalQueryVariables = refetchVariables || variables;
    if (hasGraphQLCrmSearch) {
      return refetchGraphQL(getGraphQLVariables(finalQueryVariables));
    }
    return refetchDFC(finalQueryVariables);
  }, [hasGraphQLCrmSearch, refetchDFC, refetchGraphQL, variables]);
  if (hasGraphQLCrmSearch) {
    return Object.assign({
      data: transformGraphQLResponseIntoCrmSearchResponse(graphQLData, variables.fetchParams.objectTypeId),
      refetch
    }, restGraphQL);
  }
  return Object.assign({
    data: data && CRM_OBJECT_TYPE_FIELD_NAME in data ? data[CRM_OBJECT_TYPE_FIELD_NAME] : undefined,
    refetch
  }, rest);
}